import React from 'react';
import { isMobile } from 'react-device-detect';
import styled, { css } from 'styled-components';
import Slider from 'react-slick';
import { BaseBox, FlexBox } from '@docon/docon-ui-library';
import CustomSlide from './CustomSlide';
import Image from 'shared/Image';
import { bgColor } from 'utilities/colorConfig';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const doconLogo = '/images/docon.svg';
const img1 = '/images/slider_img_1.svg';
const img2 = '/images/slider_img_2.svg';
const img3 = '/images/slider_img_3.svg';
const img4 = '/images/slider_img_4.svg';

const data = [
  {
    id: 0,
    img: img1,
    titleTxt: 'Online Appointment',
    descTxt: 'Book appointment with the doctors who are experienced and trustworthy',
  },
  {
    id: 1,
    img: img2,
    titleTxt: 'Digital Prescriptions',
    descTxt: 'Get a valid digital prescription right after your consultation',
  },
  {
    id: 2,
    img: img3,
    titleTxt: 'Health Records',
    descTxt: 'Maintain your and your family\'s health records at one place',
  },
  {
    id: 3,
    img: img4,
    titleTxt: 'Video Consultation',
    descTxt: 'Consult with your doctor through a video call',
  },
];

const settings = {
  dots: true,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 3000,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  adaptiveHeight: false,
};

const SliderWrapper = styled(FlexBox)`
  max-width: 100%;
  margin: auto;
  align-items: center;
  padding-bottom: 30px;
`;

const Root = styled(FlexBox)`
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
  background-color: ${bgColor.base};

  .doconLogo {
    height: 40px;
    margin-top: 30px;
  }

  .sliderContainer {
    max-width: 100%;
  }
  
  ${() => isMobile && css`
    width: 100%;

    .doconLogo {
      margin-top: 16px;
    }

    ${SliderWrapper} {
      min-height: 300px;
    }
  `}
`;

function SliderPane(props: any) {
  return (
    <Root {...props}>
      <Image className='doconLogo' src={doconLogo} alt='Docon' />
      <SliderWrapper>
        <BaseBox className='sliderContainer'>
          <Slider {...settings}>
            {
              data.map((item) => (
                <CustomSlide
                  key={item.id}
                  image={item.img}
                  title={item.titleTxt}
                  description={item.descTxt}
                />
              ))
            }
          </Slider>
        </BaseBox>
      </SliderWrapper>
    </Root>
  );
}

export default SliderPane;